import { createForm } from "efform";
import { forward } from "effector/effector.umd";
import { SubmitDataFx } from "../effects/SubmitDataFx";
import FTLSmartCreateGate from "../gates/FTLSmartCreateGate";
import { createStore } from "effector";
export default function FTLSmartCreateDomainStore(props) {
    const ftlSmartCreateDomainStore = createForm(props.schema);
    const formMeta = createStore({
        showErrors: false,
        isLoad: false
    });
    const submitDataFx = SubmitDataFx(props.repository);
    const gate = FTLSmartCreateGate();
    forward({
        from: ftlSmartCreateDomainStore.submitted,
        to: submitDataFx
    });
    ftlSmartCreateDomainStore.values.watch(() => ftlSmartCreateDomainStore.validate());
    gate.close.watch(() => {
        ftlSmartCreateDomainStore.fill({});
    });
    forward({
        from: submitDataFx.doneData,
        to: ftlSmartCreateDomainStore.fill
    });
    formMeta.on(ftlSmartCreateDomainStore.submitted, () => {
        return { showErrors: true, isLoad: true };
    });
    formMeta.on(submitDataFx.doneData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(submitDataFx.failData, () => {
        return { showErrors: true, isLoad: false };
    });
    formMeta.on(gate.close, () => {
        return {
            showErrors: false, isLoad: false
        };
    });
    formMeta.watch((state) => console.log('formMeta', state));
    ftlSmartCreateDomainStore.values.watch((state) => console.log('FTLSmartCreateDomain.values', state));
    ftlSmartCreateDomainStore.errors.watch((state) => console.log('FTLSmartCreateDomain.errors', state));
    return {
        store: ftlSmartCreateDomainStore,
        gate: gate,
        meta: formMeta,
        didSendData: submitDataFx.doneData
    };
}
//# sourceMappingURL=FTLSmartCreateDomainStore.js.map